import { render, staticRenderFns } from "./editSystem.vue?vue&type=template&id=4af31298&scoped=true&"
import script from "./editSystem.vue?vue&type=script&lang=js&"
export * from "./editSystem.vue?vue&type=script&lang=js&"
import style0 from "./editSystem.vue?vue&type=style&index=0&id=4af31298&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af31298",
  null
  
)

export default component.exports